export const RentalIcon = (props) => (
  <svg
    className={props.className}
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7 12H11.2V5.7L10 2C9.9 1.7 9.6 1.5 9.3 1.5H3.4C3.1 1.5 2.8 1.7 2.7 2L1.5 5.7V12H0V5.4L1.3 1.6C1.6 0.6 2.5 0 3.4 0H9.3C10.3 0 11.1 0.6 11.4 1.5L12.7 5.5V12Z"
      fill="#34363E"
    />
    <path d="M11.9998 8.80005H0.799805V10.3H11.9998V8.80005Z" fill="#34363E" />
    <path d="M11.9998 4H0.799805V5.5H11.9998V4Z" fill="#34363E" />
    <path
      d="M3.4998 7.19995H0.799805"
      stroke="#34363E"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M11.9001 7.19995H9.1001"
      stroke="#34363E"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12.6999 12.8C13.7999 12.4 14.5999 11.7 14.9999 11.3C15.2999 11 15.4999 10.5 15.4999 10.1L15.7999 6.89995H15.4999C13.4999 6.89995 12.9999 5.79995 12.8999 5.69995H12.5999H12.2999C12.2999 5.69995 11.6999 6.89995 9.6999 6.89995H9.3999L9.6999 9.99995C9.6999 10.5 9.8999 10.9 10.1999 11.2C10.5999 11.7 11.2999 12.3 12.4999 12.7H12.6999V12.8Z"
      fill="#34363E"
    />
    <path
      d="M12.7999 13.3H12.2999C10.9999 12.8 10.2999 12.1 9.7999 11.6C9.3999 11.2 9.1999 10.6 9.1999 10.1L8.8999 6.19998H9.7999C11.3999 6.19998 11.8999 5.29998 11.8999 5.29998L11.9999 5.09998H12.5999H13.1999L13.2999 5.39998C13.2999 5.39998 13.7999 6.29998 15.3999 6.29998H16.2999L15.8999 9.99998C15.7999 10.6 15.5999 11.1 15.2999 11.5C14.8999 12.1 14.0999 12.8 12.7999 13.3ZM12.5999 12.3C13.5999 11.9 14.1999 11.4 14.5999 10.9C14.7999 10.6 14.9999 10.3 14.9999 9.89998L15.1999 7.19998C13.6999 7.09998 12.8999 6.39998 12.5999 5.99998C12.2999 6.39998 11.4999 7.09998 9.9999 7.19998L10.1999 9.89998C10.1999 10.3 10.3999 10.6 10.5999 10.9C10.9999 11.3 11.5999 11.9 12.5999 12.3Z"
      fill="#34363E"
    />
  </svg>
);
